import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "categories",
  class: "pt-16 bg-gascon-gray"
}
const _hoisted_2 = { class: "container mx-auto px-4" }
const _hoisted_3 = { class: "flex flex-wrap justify-center gap-4 mb-12" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Category badges "),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categories, (category) => {
          return (_openBlock(), _createElementBlock("span", {
            key: category,
            class: "border-2 border-gascon-blue text-gascon-blue px-6 py-2 rounded-full font-medium hover:bg-gascon-blue hover:text-white transition-colors cursor-default"
          }, _toDisplayString(category), 1 /* TEXT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createCommentVNode(" Description text "),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"max-w-3xl mx-auto text-center\"><p class=\"text-gascon-blue leading-relaxed mb-4\"> Chaque jour, avant même que la ville ne se réveille, Le Comptoir Gascon est déjà en route. </p><p class=\"text-gascon-blue leading-relaxed mb-4\"> 10 ans à épauler les restaurants bordelais avec des produits triés, des prix maîtrisés et une disponibilité qui ne faiblit jamais. </p><p class=\"text-gascon-blue leading-relaxed mb-4\"> Un coup de fil, et l&#39;équipe répond. Toujours là, toujours prête, toujours efficace. </p><p class=\"text-gascon-blue leading-relaxed font-medium\"> Ici, on ne parle pas : on livre. </p><p class=\"text-gascon-blue leading-relaxed mt-6 font-bold\"> Le plan d&#39;attaque : le bon produit, au bon moment, au bon prix. </p></div>", 1))
    ])
  ]))
}